export const loginUrl = () => `/auth/signin`;
export const logoutUrl = (token: string) => `/auth/logout/${token}`;
export const resetPasswordUrl = () => `/auth/reset-password`;
